import React, { useState } from "react";
import {
    SovosDialog,
    SovosDialogContent,
    SovosDialogTitle,
    SovosBox,
    SovosTypography,
    SovosRadioGroup,
    SovosButton,
    SovosDialogActions,
} from "mosaic-react";
import { InfoOutlined } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "./XlsxOrCsvDialog.module.sass";
import { connect } from "react-redux";

const XlsxOrCsvDialog = (props) => {
    const { data, cancel, i18n, downloading } = props;
    const { title } = data;

    const { totalLinesCsv, downloadableQueries, download, locale, downloadCsvStreamAction } =
        useGlobalValue();

    const options = [
        { label: i18n`XLSX Export (Excel)`, value: "xlsx" },
        { label: i18n`CSV Export`, value: "csv" },
    ];

    const [typeOfDownload, setTypeOfDownload] = useState(options[0].value);

    const handleTypeOfDownloadChange = (e) => {
        setTypeOfDownload(e.target.value);
    };

    const handleConfirm = () => {
        if (typeOfDownload === "csv") {
            downloadCsvStreamAction && downloadCsvStreamAction(downloadableQueries, locale, cancel);
        } else {
            download && download(downloadableQueries, locale, cancel);
        }
    };

    return (
        <SovosBox>
            <SovosDialog open={true}>
                {downloading ? (
                    <SovosBox className={styles["backdrop"]}>
                        <SovosBox className={`${styles["loader"]}`} />
                    </SovosBox>
                ) : null}
                <SovosDialogTitle>{title}</SovosDialogTitle>
                <SovosDialogContent>
                    <SovosBox
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                        }}
                    >
                        <SovosRadioGroup
                            sx={{ paddingLeft: "1.25rem" }}
                            value={typeOfDownload}
                            onChange={handleTypeOfDownloadChange}
                            options={options}
                        />
                    </SovosBox>
                </SovosDialogContent>
                <SovosDialogActions>
                    <SovosBox>
                        <SovosBox
                            sx={{
                                marginBottom: "8px",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                            }}
                        >
                            <SovosButton
                                variant="text"
                                onClick={() => {
                                    cancel && cancel();
                                }}
                            >
                                {i18n`Cancel`}
                            </SovosButton>
                            <SovosButton onClick={handleConfirm}>
                                {i18n`Confirm`}
                            </SovosButton>
                        </SovosBox>
                        <SovosBox
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <InfoOutlined sx={{ marginRight: "8px" }} />
                            <SovosTypography
                                children={i18n`Limit of ${totalLinesCsv} rows per Excel file`}
                            />
                        </SovosBox>
                    </SovosBox>
                </SovosDialogActions>
            </SovosDialog>
        </SovosBox>
    );
};

export default connect(({ downloading }) => ({ downloading }), {})(XlsxOrCsvDialog);
